(function($) {
	var prev = 0;
	var $window = $(window);
	var nav = $('.scrollhide-nav');
	var navbarHeight = $('.scrollhide-nav').outerHeight();

	$window.on('scroll', function(){
	  var scrollTop = $window.scrollTop();
	  
	  if( scrollTop < navbarHeight+60 ){
	  	nav.addClass('transparent');
	  } else {
	  	nav.removeClass('transparent');
	  }

	  if( scrollTop > prev && scrollTop > navbarHeight ){
	    nav.addClass('hidden');
	  } else {
	    nav.removeClass('hidden');
	  }

	  prev = scrollTop;
	});
})( jQuery );